// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"73aec5ca","513":"905162c9"}[chunkId] + ".chunk.js";
};